/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateTaskInput = {
    title?: string;
    description?: string;
    status?: UpdateTaskInput.status;
    due_date?: string;
    is_key_event?: boolean;
    project_id?: string;
    assignees?: Array<string>;
    reviewers?: Array<string>;
};
export namespace UpdateTaskInput {
    export enum status {
        PLANNED = 'planned',
        IN_PROGRESS = 'in-progress',
        REVIEW = 'review',
        DONE = 'done',
    }
}

